import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'

export default class DiabetesActions  {
  diabetes (cedula,cb) {
    var endpoint ="/api/v1/diabetes/gestion/"
    return request
    .get(endpoint)
    .query({ documento: cedula })
    .set('Authorization', `Bearer ${getToken()}`)
    .set('Accept', 'application/json')
    .end((err, res) => {
        cb(res.body)
    })

  }
  borrar (_id, url, cb) {
    var endpoint  = url
    return request
    .delete(endpoint)
    .query({ _id: _id })
    .set('Authorization', `Bearer ${getToken()}`)
    .set('Accept', 'application/json')
    .end((err, res) => {
        alert("dato borrado")
        cb(res.body)
    })
  }
  actualizar (objecto, url, cb) {
    var endpoint = url
    return request
    .put(endpoint)
    .send(objecto)
    .set('Authorization', `Bearer ${getToken()}`)
    .set('Accept', 'application/json')
    .end((err, res) => {
      alert("paciente Actualizado")
        cb(res.body)
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/Actions/DiabetesActions.js